import { mediaManagerSortClick } from '@wix/bi-logger-media-manager-g6/v2';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ToggleButtonWithPopover } from '../../../components/common';
import { bi } from '../../../services/loggers/bi';
import { memoizedOver } from '../../../utils/memoize';
import { IOuter } from './SortSwitcher.types';
import { SortSwitcherIcons } from './SortSwitcherIcons';
import { SortSwitcherMenu } from './SortSwitcherMenu';

export const SortSwitcher: FC<IOuter> = ({ sort, className, onSortChange }) => {
  const trackSortClick = useCallback(() => bi.logger().report(mediaManagerSortClick({})), []);

  const CurrentIcon = SortSwitcherIcons[sort];

  const getPopoverContent = useCallback(
    ({ closeMenu }) => <SortSwitcherMenu sort={sort} onSortChange={memoizedOver(onSortChange, closeMenu)} />,
    [sort, onSortChange],
  );

  return (
    <ToggleButtonWithPopover
      className={className}
      tooltipContent={<FormattedMessage id="sort-switcher.hint" />}
      popoverContent={getPopoverContent}
      onClick={trackSortClick}
      dataHook="sort-switcher-button"
    >
      <CurrentIcon />
    </ToggleButtonWithPopover>
  );
};
